<!-- APP HEADER -->
@if (showAppHeader) {
  <app-header
    [hidePortal]="hidePortalMenu"
    [showTucieloLogo]="!showImage"
  ></app-header>
}

<!-- ALL THE TEXT -->
<ng-container>
  <ng-content></ng-content>

  <!-- BACKGROUND-IMAGE -->
  @if (imageData$ | async; as imageData) {
    <div class="background" [ngClass]="imageData.classes">
      <div class="background-overlay"></div>
      @if (showImage) {
        <div class="background-image" [preloadImage]="imageData.imageUrl"></div>
      }
    </div>
  }
</ng-container>
